import type { MouseEventHandler, ReactElement, ReactNode, RefObject } from 'react';

export enum ETooltipPlacement {
    top = 'top',
    topStart = 'top-start',
    topEnd = 'top-end',
    right = 'right',
    rightStart = 'right-start',
    rightEnd = 'right-end',
    bottom = 'bottom',
    bottomStart = 'bottom-start',
    bottomEnd = 'bottom-end',
    left = 'left',
    leftStart = 'left-start',
    leftEnd = 'left-end',
}

export enum ETooltipSize {
    small = 's',
    medium = 'm',
    large = 'l',
    fit = 'fit',
}

export enum ETooltipAppearance {
    white = 'white',
    blue = 'blue',
    blueContrast = 'blueContrast',
    green = 'green',
    orange = 'orange',
    purple = 'purple',
    dark = 'dark',
    contrast = 'contrast',
    darkInverse = 'darkInverse',
    blueLight = 'blueLight',
}

export interface ITooltipProps {
    children?: ReactElement | ReactNode;
    className?: string;
    arrowClassName?: string;
    contentClassName?: string;
    closeClassName?: string;
    target: RefObject<HTMLElement> | Element | null;
    title?: string;
    text?: string | React.ReactNode;
    img?: string;
    buttonText?: string;
    theme?: 'light' | 'dark';
    isAlternativeButton?: boolean;
    appearance?: ETooltipAppearance;
    size?: ETooltipSize;
    placement: ETooltipPlacement;
    closable?: boolean;
    hideArrow?: boolean;
    closeOnOutsideClick?: boolean;
    closeOnContextMenu?: boolean;
    closeOnScroll?: boolean;
    withinModal?: boolean;
    smallArrow?: boolean;
    qaId?: string;
    overAll?: boolean;
    usePortal?: boolean;
    smallClose?: boolean;
    onClick?: (e?: Event) => void;
    onShow?: () => void;
    onClose?: (e?: Event) => void;
    onCrossClose?: () => void;
    onTooltipClick?: MouseEventHandler<HTMLDivElement>;
    paddingRight?: number;
    allowFlip?: boolean;
    belowSticky?: boolean;
    isRebrandingQuotaLanding?: boolean;
    buttonFitContent?: boolean;
    imageWidth?: number;
    leftOffset?: number;
    topOffset?: number;
    closeOnNoTarget?: boolean;
    autoUpdateOnResize?: boolean;
}
